import {SmartComponent} from "smart-component-js";
import IMUtils from "../business/IMUtils";

class HeroBannerComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        params = params || {};
        params.className = "HeroBannerComponent";
        super(element, parentComponent, params);
        this.isRtl = KD_COMMON_CONSTANTS.IS_RTL;
        this.$wrapper = $(element);
        this.checkNewThumbs = document.querySelector('.newThumbs');
        this.chevronTimeout = false;
        this.hero = this.element;
        this.dots = this.element.querySelector('.owl-dots');
        this.notStickyClass = 'not-sticky';
        this.stickyClass = 'sticky';
        this.init();
    }

    init() {
        $("body").addClass("ab-test-active");

        $(window).on('scroll', () => {
            this.fakeDebounceChevron();
        });

        this.$owl = this.$wrapper.find('.owl-carousel.hero-banner-container');
        this.$owlDots = this.$wrapper.find('#owl-dots');

        this.$owl.on('resized.owl.carousel', () => {
            this.resize();
        });
        this.$owl.on('initialized.owl.carousel', () => {
            this.resizeSlideContents();
            this.resize();
        });

        this.initializeSwipers();

        if (this.$wrapper.parents('.hidden-forced').length > 0) {
            this.$wrapper.parents('.hidden-forced').removeClass('hidden-forced');
        }

        this.$wrapper.on('click', '.owl-dot', (e) => {
            this.$owl.trigger('to.owl.carousel', [$(e.currentTarget).parents('.owl-item').index(), 300]);
        });

        if (this.checkNewThumbs) {
            this.bannerObserver.observe(this.hero);
        }
    }

    bannerObserver = new IntersectionObserver(
        ([entry]) => {
            this.dots.classList.toggle(this.stickyClass, entry.isIntersecting);
            this.dots.classList.toggle(this.notStickyClass, !entry.isIntersecting);
        },
        {
            root: null,
            threshold: 0,
            rootMargin: IMUtils.isMobile() ? `-${document.querySelector('header').clientHeight}px 0px 0px 0px` : `-${document.querySelector('header').clientHeight + document.querySelector('.newThumbs .the-flying-cta').clientHeight}px 0px 0px 0px`
        }
    );

    initializeSwipers() {
        this.$owl.owlCarousel({
            loop: true,
            rtl: this.isRtl,
            margin: 0,
            autoHeight: true,
            nav: false,
            dots: true,
            autoplay: true,
            autoplayHoverPause: true,
            autoplayTimeout: 6000,
            dotsContainer: 'owl-dots hero-banner-owl-dots',
            responsive: {
                0: {
                    items: 1
                }, 1000: {
                    items: 1
                }
            },
            onChanged: (event) => {
                this.onSlideChange(event.page.index);
            }
        });

        this.onSlideChange(0);

        this.$owlDots.owlCarousel({
            margin: 15,
            rtl: this.isRtl,
            autoHeight: true,
            autoWidth: true,
            nav: false,
            dots: false,
            responsive: {
                0: {
                    margin: 15
                }, 768: {
                    margin: 50
                }
            },
        });

        this.resize();
    }

    resizeSlideContents() {
        if (IMUtils.isMobile()) {
            let minHeight = 0;
            this.$wrapper.find('.hero-banner-item .hero-banner-content').each((i, el) => {
                if ($(el).outerHeight() > minHeight) {
                    minHeight = $(el).outerHeight();
                }
            });
            this.$wrapper.find('.hero-banner-item .hero-banner-content').css('min-height', parseInt(minHeight) + 10);
        }
    }

    /**
     * Fake Debounce perchè è solo una funzione che riduce il numero di occorrenze, ma ogni 200ms esegue un update
     */
    fakeDebounceChevron() {
        if (this.chevronTimeout === false) {
            this.chevronTimeout = true;
            setTimeout(() => {
                this.chevronTimeout = false;
                this.chevronThings();
            }, 200);
        }
    }

    chevronThings() {
        this.$wrapper.find('.chevron').toggle(($(window).scrollTop() + $(window).height()) < ($('#hero-banner').offset().top + $('#hero-banner').height() + 50));
    }

    onSlideChange(index) {
        this.$wrapper.find('#owl-dots .owl-dot.active').removeClass('active');
        this.$wrapper.find('#owl-dots .owl-dot:eq(' + (index) + ')').addClass('active');

        if (index > 0) {
            index--
        }
        this.$owlDots.trigger('to.owl.carousel', [index, 300]);

        this.resize();
    }

    resize() {
        if (IMUtils.isMobile()) {

            setTimeout(() => {
                let dotTop = parseInt(this.$wrapper.find('.active .hero-banner-image').outerHeight()) - 105;
                this.$wrapper.find('#owl-dots').addClass('show');

                if (!this.checkNewThumbs) {
                    this.$wrapper.find('#owl-dots').css('top', dotTop);
                }
            }, 100);

            //Su mobile bisogna forzare le cta in modo che siano tutte larghe uguali, ma questo solo se sono più di 1 ovviamente.
            this.$wrapper.find('.hero-banner-btns').each((i, el) => {
                let btns = $(el).find('.btn-banner.tsp').width('');
                if (btns.length > 1) {
                    let maxWidth = 0;
                    btns.each((j, bel) => {
                        if (maxWidth < $(bel).width()) {
                            maxWidth = $(bel).width();
                        }
                    })
                    btns.width(parseInt(maxWidth));
                }
            });
        } else {
            if (!this.checkNewThumbs) {
                this.$wrapper.find('#owl-dots').css('top', 'auto');
            }
            this.$wrapper.find('.hero-banner-btns .btn-banner.tsp').width('auto');
        }

        this.fakeDebounceChevron();
    }
}

export default HeroBannerComponent;